import { Map } from "immutable";

import {
  compose,
  connect,
  toJS
} from "seneca-common/components/container-utils";
import { validateString } from "seneca-common/utils/functions/validation/validateString";

import {
  getCollectTeacherRole,
  getCollectUserSchool,
  getRegion
} from "features/regions/selectors";
import { userAccountType } from "features/user/consts";

import makeReduxFormWrapper from "../../containers/makeSignUpDetailsReduxFormWrapper";
import SignUpFormTeacherDetails from "./SignUpFormTeacherDetails";

function mapStateToProps(state: any) {
  return {
    includeSchool: getCollectUserSchool(state),
    region: getRegion(state),
    collectTeacherRole: getCollectTeacherRole(state)
  };
}

const connector = connect(mapStateToProps);

const validateTeachers = (valuesIn: Map<string, string>, props: any) => {
  const validationOutput: {
    nickname: string | null | undefined;
    teacherRole?: string | null | undefined;
    school?: string | null | undefined;
  } = {
    nickname: validateString(valuesIn.get("nickname"))
  };

  if (props.collectTeacherRole) {
    validationOutput.teacherRole =
      validateString(valuesIn.get("teacherRole")) && "Please choose your role";
  }

  if (props.includeSchool && !valuesIn.getIn(["school", "cantFindOption"])) {
    validationOutput.school =
      validateString(
        valuesIn.getIn(["school", "schoolId"]) as string | undefined | null
      ) && "Please choose your school";
  }

  return validationOutput;
};

const getTeacherFormDetails = (formValues: any, props: any) => {
  const details: any = {
    type: userAccountType.schoolteacher,
    nickname: formValues.get("nickname"),
    teacherSubjects: formValues.get("teacherSubjects")
  };

  if (props.includeSchool) {
    details.schoolId = formValues.getIn(["school", "schoolId"]);
  }

  if (props.collectTeacherRole) {
    details.teacherRole = formValues.get("teacherRole");
  }

  return details;
};

const reduxFormWrapper = makeReduxFormWrapper(
  validateTeachers,
  getTeacherFormDetails
);

export default compose(
  connector,
  // @ts-ignore
  toJS,
  reduxFormWrapper
  // @ts-ignore
)(SignUpFormTeacherDetails);
